var _circle, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudsAndSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 17,
    fill: "#ffd45c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffd45c",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 7v9M33 50v9M7 33h9M50 33h9M14 14l7 7M45 45l7 7M52 14l-7 7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 70h42a15 15 0 0 0 0-30 22 22 0 0 0-41-8A19 19 0 0 0 27 70z",
    fill: "#dce8f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 70h42a15 15 0 0 0 0-30 22 22 0 0 0-41-8A19 19 0 0 0 27 70z",
    fill: "none",
    stroke: "#9db5c7",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsAndSun);
export default __webpack_public_path__ + "static/media/clouds-and-sun.ef87d0bb6355ab76000741d6ac520b47.svg";
export { ForwardRef as ReactComponent };